import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { LandingHeader } from 'components/header'

import CSSModules from 'react-css-modules'
import styles from './standard_landing_header.scss'
import config from 'config'

class StandardLandingHeader extends Component {

	render() {

		return (
			<div styleName="landingheader_area">
				<LandingHeader {...this.props}>
					{ this.props.linkHome &&
						<a styleName="landingheader_area_link" href={config.www}>
							<h1 styleName="landingheader_area_logo"></h1>
						</a>
					}
					{ !this.props.linkHome &&
						<h1 styleName="landingheader_area_logo"></h1>
					}
					{this.props.children}
				</LandingHeader>
			</div>
		)
	}
}

StandardLandingHeader.propTypes = {
	children: PropTypes.node,
	linkHome: PropTypes.bool,
}

StandardLandingHeader.defaultProps = {
	linkHome: true,
}

StandardLandingHeader = CSSModules(StandardLandingHeader, styles, {allowMultiple: true})

export default StandardLandingHeader
